import React from "react";

/**
 * Inline JSON-LD structured-data injector.
 * Renders a <script type="application/ld+json"> in the current component tree.
 * Googlebot & Bingbot execute JS and parse this. Great for SEO/GSO.
 */
export const JsonLd = ({ data }) => (
  <script
    type="application/ld+json"
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
);

export default JsonLd;
